// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Enum to specify the resource for which change feed is being fetched.
 */
export enum ChangeFeedResourceType {
  FeedRange,
  PartitionKey,
}
